/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useRef } from 'react';

import classNames from 'classnames';

import useOnClickOutside from '../../hooks/useOnClickOutside';
import classes from './styles.module.scss';

export default function ArrowMenu({
  children,
  isVisible,
  setIsVisible,
  options,
}) {
  const dropdownRef = useRef();

  const hideOptionsOnClick = (event, action) => {
    event.stopPropagation();
    if (action) {
      action();
    }
    setIsVisible(false);
  };

  useOnClickOutside(dropdownRef, () => setIsVisible(false));

  return (
    <div
      ref={dropdownRef}
      className={classes.ArrowMenu}
      onClick={(e) => {
        e.stopPropagation();
        e.nativeEvent?.stopImmediatePropagation();
        setIsVisible((prevState) => !prevState);
      }}
    >
      <div className={classes.trigger}>{children}</div>
      {isVisible && options?.length ? (
        <div className={classes.options}>
          <ul className={classes.options}>
            {options.map((option) => (
              <li
                key={option.label}
                onClick={(e) => {
                  e.stopPropagation();
                  hideOptionsOnClick(e, option.onClick);
                }}
                className={classNames({
                  [classes.lastItemLine]: option.withBorder,
                  [classes.disabled]: option.disabled,
                })}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
